import {
  ApiResponse,
  CountryDto,
  LanguageDto,
  TenantSettingsDto,
  UpdateTenantSettingsDto,
} from '@splitsecondconnect/ultramarine-shared';
import { MANAGE_API_PATHS } from '../data';
import { HttpClient } from '@angular/common/http';
import { environment } from '@marineform/environment';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { catchError, EMPTY, Observable, tap } from 'rxjs';
import { AlertsService } from './alerts.service';
import { httpErrorMessage } from '../helpers/http-error-message';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  #http = inject(HttpClient);
  #alerts = inject(AlertsService);
  #transloco = inject(TranslocoService);

  getSettings() {
    return this.#http.get<ApiResponse<TenantSettingsDto>>(
      `${environment.ultramarineBaseUrl}/${MANAGE_API_PATHS.SETTINGS}`,
    );
  }

  updateSettings(
    record: Partial<UpdateTenantSettingsDto>,
  ): Observable<ApiResponse<TenantSettingsDto>> {
    return this.#http
      .put<ApiResponse<TenantSettingsDto>>(
        `${environment.ultramarineBaseUrl}/${MANAGE_API_PATHS.SETTINGS}`,
        record,
      )
      .pipe(
        tap(() =>
          this.#alerts.success(
            this.#transloco.translate('alerts|record-updated-successfully'),
            { sound: 'light' },
          ),
        ),
        catchError((error) => {
          void this.#alerts.error(
            httpErrorMessage(
              error,
              this.#transloco.translate('alerts|something-went-wrong'),
            ),
          );
          return EMPTY;
        }),
      );
  }
  getCountries() {
    return this.#http.get<ApiResponse<CountryDto[]>>(
      `${environment.ultramarineBaseUrl}/${MANAGE_API_PATHS.COUNTRIES}`,
    );
  }
  getLanguages() {
    return this.#http.get<ApiResponse<LanguageDto[]>>(
      `${environment.ultramarineBaseUrl}/${MANAGE_API_PATHS.LANGUAGES}`,
    );
  }
}
